"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var redux_1 = require("redux");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var HoCs_1 = require("utils/HoCs");
var hooks_2 = require("utils/hooks");
var useInfiniteScroll_1 = __importDefault(require("utils/hooks/useInfiniteScroll"));
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var RowMaker_1 = __importDefault(require("../TableMaker/RowMaker"));
var tableConf_1 = require("./tableConf");
var TransactionContactTableMenu_1 = __importDefault(require("./TransactionContactTableMenu"));
var Header = (0, HeaderMaker_1.default)(tableConf_1.contactsTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.contactsTableConf);
var TransactionContact = function () {
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var _a = __read(react_1.default.useState(true), 2), showAll = _a[0], setShowAll = _a[1];
    var _b = __read((0, hooks_2.useSearch)(), 2), searchText = _b[0], setSearchText = _b[1];
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        { collection: 'transaction_contacts', where: [['companyId', '==', company === null || company === void 0 ? void 0 : company.id], ['noMatch', '==', true]] },
    ]; });
    var transactionContacts = (0, react_redux_1.useSelector)(ordered_1.selectTransactionContacts);
    var transactionContactsToShow = showAll ? transactionContacts : transactionContacts === null || transactionContacts === void 0 ? void 0 : transactionContacts.filter(function (tC) { return !tC.serviceId && !tC.isNotSaas; });
    var searchedTransactionContactsToShow = searchText
        ? transactionContactsToShow === null || transactionContactsToShow === void 0 ? void 0 : transactionContactsToShow.filter(function (_a) {
            var name = _a.name;
            return name === null || name === void 0 ? void 0 : name.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase());
        })
        : transactionContactsToShow;
    var sortedTransactionContacts = (0, hooks_1.useSortArray)(searchedTransactionContactsToShow, tableConf_1.contactsTableConf.extractors);
    var _c = __read((0, useInfiniteScroll_1.default)(sortedTransactionContacts || [], 100), 2), sortedTransactionContactsPaged = _c[0], loaderRef = _c[1];
    if (!(0, react_redux_firebase_1.isLoaded)(transactionContacts)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Transaction Contacts", description: "Transaction Contacts" }), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ height: "100%", width: "100%", pb: 8 }, { children: [(0, jsx_runtime_1.jsx)(TransactionContactTableMenu_1.default, { searchText: searchText, setSearchText: setSearchText, showAll: showAll, setShowAll: setShowAll }), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 680 }, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsxs)(TableBody_1.default, { children: [sortedTransactionContactsPaged === null || sortedTransactionContactsPaged === void 0 ? void 0 : sortedTransactionContactsPaged.map(function (transaction) { return (0, jsx_runtime_1.jsx)(Row, { item: transaction }, transaction.id); }), (0, jsx_runtime_1.jsx)("div", { ref: loaderRef })] })] }))] }))] }));
};
exports.default = (0, redux_1.compose)(HoCs_1.HasCompanyHoC, function (Component) { return (0, SortHoC_1.default)(Component, { key: 'name', order: 1 }); })(TransactionContact);
